import * as server from "@/utils/http"

export const _page = params => server.get("/data-info/page", params);

export const _get = params => server.get("/data-info/get", params);

export const _save = params => server.post(params.id ? "/data-info/update" : "/data-info/save", params);

//发布
export const _publish = params => server.get("/data-info/publish", params);
//撤回
export const _revocate = params => server.get("/data-info/revocate", params);

export const _barcode= params => server.get("/data-info/getPhysicalBarcode", params);
export const _printPhysicalForm= params => server.get("/data-info/print-physicalForm", params);
export const _download= params => server.post("/data-info/download", params);
export const _healthPromotionSystem = params => server.download("/data-info/health-promotion-system", params);
export const _healthPromotionEye = params => server.download("/data-info/health-promotion-eye", params);
export const _uploadPhysicalData = params => server.postfrom("/data-info/physical-data", params);
export const _refraction = params => server.postfrom("/data-info/refraction", params);
export const _physicalDataTemplate = params => server.download("/data-info/physical-data-template", params);

export const _updateStatus = params => server.get("/data-info/updateStatus", params);

//批量下载体检报告
export const _getBatchReportType = params => server.get("/data-info/getBatchReportType", params);
export const _batchPrintReportByPdf = params => server.post("/data-info/batchPrintReportByPdf", params);

//批量健康评价
export const _batchEvaluate = params => server.get("/data-info/batch-evaluate", params);
export const _initEvaluate = params => server.get("/data-info/init-evaluate", params);
export const _monitorRedisKey = params => server.get("/monitor-redis-progress/monitorRedisKey", params);

//批量打印协议书
export const _batchPrintNotice = params => server.get("/data-info/batch-print-notice", params);

// 批量打印条形码
export const _batchPrintBarcode = params => server.get("/data-info/batch-print-barcode", params);

export const _batchPrintPhysicalForm = params => server.get("/data-info/batch-print-physicalForm", params);

// 批量发布
export const _batchPublish = params => server.get("/data-info/batch-publish", params);

// 批量撤回
export const _batchRevocate = params => server.get("/data-info/batch-revocate", params);

// 导出
export const _export = params => server.download("/data-info/export", params);

// 导出体检明细
export const _exportPhysicalDetail = params => server.download("/data-info/export-physical-detail", params);

// 导出统计数据
export const _exportStatistics = params => server.download("/data-info/export-statistics", params);
export const _fullStatistics = params => server.download("/data-info/full-statistics", params);

export const _ophthalmology = params => server.download("/data-info/ophthalmology", params);

// 展示条形码
export const _getPhysicalBarcode = params => server.get("/data-info/getPhysicalBarcode", params);

//#########体检单页面接口#########

// 获取体检日期-体检套餐
export const _getPhysicalData = params => server.get("/data-info/getPhysicalData", params);

// 获取体检单个人信息
export const _getResidentInfo = params => server.get("/data-info/getResidentInfoById", params);

//获取体检单数据
export const _getPhysicalForm = params => server.get("/data-project/physicalForm", params);
//保存体检单数据

export const _savePhysicalForm = params => server.post("/data-project/save", params);

//获取体检报告类型
export const _getPhysicalReportType = params => server.get("/physical-report/reportType", params);
